import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaBars, FaTimes, FaUserCircle } from "react-icons/fa";
import nhsLogo from "../assets/nhs-logo.png";
import { useFeatureFlags } from "../contexts/FeatureFlagsContext";

export default function PublicHeader({ session, profile }) {
  const [open, setOpen] = useState(false);
  const { isRouteEnabled } = useFeatureFlags();

  const accountHref =
    profile?.position === "Patient"
      ? "/patient-portal"
      : session
        ? "/intranet/portal"
        : "/login";

  const accountLabel =
    profile?.position === "Patient"
      ? "Patient account"
      : session
        ? "Staff intranet"
        : "Staff login";

  const closeMenu = () => setOpen(false);

  return (
    <header className="pguh-public-site-header">
      <div className="pguh-public-site-header__top">
        <div className="nhsuk-width-container pguh-public-site-header__top-inner">
          <Link className="pguh-public-site-brand" to="/" onClick={closeMenu}>
            <img src={nhsLogo} alt="NHS" />
            <span>
              <strong>Royal University Hospitals Trust</strong>
            </span>
          </Link>

          <div className="pguh-public-site-header__actions">
            <Link className="pguh-public-site-account" to={accountHref}>
              <FaUserCircle aria-hidden="true" />
              <span>{accountLabel}</span>
            </Link>

            <button
              type="button"
              className="pguh-public-site-menu-button"
              aria-expanded={open}
              aria-controls="public-site-navigation"
              onClick={() => setOpen((current) => !current)}
            >
              {open ? (
                <FaTimes aria-hidden="true" />
              ) : (
                <FaBars aria-hidden="true" />
              )}
              <span>Menu</span>
            </button>
          </div>
        </div>
      </div>

      <nav
        id="public-site-navigation"
        className={`pguh-public-site-nav${open ? " pguh-public-site-nav--open" : ""}`}
        aria-label="Public website"
      >
        <div className="nhsuk-width-container pguh-public-site-nav__inner">
          {isRouteEnabled("/") && <NavLink to="/" end onClick={closeMenu}>Home</NavLink>}
          {isRouteEnabled("/shifts") && <NavLink to="/shifts" onClick={closeMenu}>Shifts</NavLink>}
          {isRouteEnabled("/vacancies") && <NavLink to="/vacancies" onClick={closeMenu}>Vacancies</NavLink>}
          {isRouteEnabled("/patient-portal") && <NavLink to="/patient-portal" onClick={closeMenu}>Patient portal</NavLink>}
          <NavLink to={accountHref} onClick={closeMenu}>
            {accountLabel}
          </NavLink>
        </div>
      </nav>
    </header>
  );
}
